module.exports = __webpack_public_path__ + "assets/steps-pointer.dfb2ded3.svg";